//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import styledata from "../assets/dances.json";
export default {
  data() {
    return {
      style: this.$route.params.style,
      styles: styledata,
    };
  },
  computed: {},
  created() {
    if (!this.$route.params.danceid) {
      this.$router.push({
        name: "DanceDetails",
        params: { danceid: this.styles[this.style].dances[0] },
      });
    }
  },
};
